import styled from 'styled-components';

import { brandColors } from '../../../constants/colors';

const { SUBZERO_HEX, WOLF_HEX } = brandColors;

type SwiperContainerProps = {
  isMobile?: boolean;
  paginationColor?: typeof SUBZERO_HEX | typeof WOLF_HEX;
};

export const SwiperContainer = styled.div.attrs({
  className: 'relative'
})<SwiperContainerProps>`
  .swiper-pagination {
    position: absolute;
    bottom: -40px !important;
    font-size: 10px;
  }

  .swiper-pagination-bullet {
    cursor: pointer;
    margin: 5px;
    padding: 12px
    border-radius: 50%;
    background-color: #8f8f8f;
  }

  .swiper-pagination-bullet-active {
    background-color: ${(props) => props.paginationColor};
  }
`;

export const Container = styled.div.attrs({})<SwiperContainerProps>`
  .image-container::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    z-index: 20;
  }

  .image-container:hover::after {
    background-color: ${(props) =>
      props.isMobile ? 'transparent' : 'rgba(0, 129, 198, 0.8)'};
  }
`;
